<template>
    <div class="remoteConfigDiv">
        <div class="contentHeader">
            <div>
                <el-form :inline="true" ref="form" label-width="90px">
                    <el-row>
                        <el-col :span="3">
                            <el-button size="mini" @click="dialogEditRemoteConfigVisible=true">添加</el-button>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="环境：">
                                <el-select v-model="env" filterable placeholder="请选择">
                                    <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="name：">
                                <el-select v-model="name" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in namesOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="app：">
                                <el-select v-model="app" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in appsOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item size="mini" label="label：">
                                <el-select v-model="labelValue" filterable allow-create default-first-option clearable placeholder="请选择">
                                    <el-option v-for="item in labelsOptions" :key="item.value" :label="item.key"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <el-table
                :data="tableData"
                style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="table-expand">
                        <el-form-item label="id：">
                            <span>{{ props.row.id }}</span>
                        </el-form-item>
                        <el-form-item label="app：">
                            <span>{{ props.row.app }}</span>
                        </el-form-item>
                        <el-form-item label="name：">
                            <span>{{ props.row.name }}</span>
                        </el-form-item>
                        <el-form-item label="label：">
                            <span>{{ props.row.label }}</span>
                        </el-form-item>
                        <el-form-item label="环境：">
                            <span>{{ props.row.env }}</span>
                        </el-form-item>
                        <el-form-item label="创建时间：">
                            <span>{{ props.row.createdOn }}</span>
                        </el-form-item>
                        <el-form-item label="修改时间：">
                            <span>{{ props.row.modifiedOn }}</span>
                        </el-form-item>
                        <el-form-item label="value：">
                            <div v-if="props.row.value.length > 20">
                                <el-popover
                                        placement="top-start"
                                        width="600"
                                        trigger="hover"
                                        :content="props.row.value">
                                    <span slot="reference">{{props.row.value.substring(0, 20) + '...'}}</span>
                                </el-popover>
                            </div>
                            <div v-else>
                                <span>{{props.row.value}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="文件类型：">
                            <span>{{ props.row.type }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column
                    label="app"
                    prop="app">
            </el-table-column>
            <el-table-column
                    label="环境"
                    prop="env">
            </el-table-column>
            <el-table-column
                    label="label"
                    prop="label">
            </el-table-column>
            <el-table-column
                    label="type"
                    prop="type">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" @click="tableEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="tableDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                :total="total"
                :current-page="pageNumber"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
        ></el-pagination>

        <el-dialog :title="remoteConfigFrom.id === '' ? '新增RemoteConfig' : '编辑RemoteConfig'"
                   width="62%" :visible.sync="dialogEditRemoteConfigVisible" center
                   :close-on-click-modal="false"
                   @closed="dialogEditRemoteConfigClosedFn">
            <el-form label-position="right" label-width="110px" :rules="rules" :model="remoteConfigFrom"
                     ref="remoteConfigFrom">
                <el-form-item label="name：" prop="name">
                    <el-input v-model="remoteConfigFrom.name" placeholder="请输入name"></el-input>
                </el-form-item>
                <el-form-item label="value：" prop="value">
                    <el-input type="textarea" autosize v-model="remoteConfigFrom.value"
                              placeholder="请输入value"></el-input>
                </el-form-item>
                <el-form-item label="环境：" prop="env">
                    <el-select v-model="remoteConfigFrom.env" filterable placeholder="请选择">
                        <el-option v-for="item in envOptions" :key="item.value" :label="item.key"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="app：" prop="app">
                    <el-input v-model="remoteConfigFrom.app" placeholder="请输入Application"></el-input>
                </el-form-item>
                <el-form-item label="Label：" prop="label">
                    <el-input v-model="remoteConfigFrom.label" placeholder="请输入label"></el-input>
                </el-form-item>
                <el-form-item label="type：" prop="type">
                    <el-radio-group v-model="remoteConfigFrom.type">
                        <el-radio label="properties"></el-radio>
                        <el-radio label="yaml"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditRemoteConfigVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmButton('remoteConfigFrom')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data: () => {
            return {
                tableData: [],
                pageSizes: [10, 20, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0,
                name: '', // 默认查找all
                app: '',
                labelValue: '',
                env: '',
                namesOptions: [],
                appsOptions: [],
                labelsOptions: [],
                envOptions: [],
                dialogEditRemoteConfigVisible: false,
                remoteConfigFrom: {
                    id: '',
                    name: '',
                    value: '',
                    env: '',
                    app: '',
                    label: '',
                    type: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入name', trigger: 'blur'}
                    ],
                    value: [
                        {required: true, message: '请输入value', trigger: 'blur'}
                    ],
                    env: [
                        {required: true, message: '请选择环境', trigger: 'blur'}
                    ],
                    app: [
                        {required: true, message: '请输入app', trigger: 'blur'}
                    ],
                    label: [
                        {required: true, message: '请输入label', trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: '请选择文件类型', trigger: 'blur'}
                    ]
                }
            }
        },
        mounted: function () {
            this.getEnvOptions();
            if (this.env !== '') {
                this.getNamesOptions();
                this.getAppsOptions();
                this.getLabelsOptions();
                this.getTableData();
            }
        },
        watch: {
            env() {
                this.getNamesOptions();
                this.getAppsOptions();
                this.getLabelsOptions();
                this.getTableData();
            },
            name() {
                this.getTableData();
            },
            app() {
                this.getTableData();
            },
            labelValue() {
                this.getTableData();
            }
        },
        methods: {
            getTableData: function () {
                const self = this;
                let params = {};
                params.pageNum = self.pageNumber - 1;
                params.pageSize = self.pageSize;
                params.env = self.env;
                if (self.name !== '') {
                    params.name = self.name;
                }
                if (self.app !== '') {
                    params.app = self.app;
                }
                if (self.labelValue !== '') {
                    params.label = self.labelValue;
                }
                self.$axios_api.getRemoteConfigList(params).then(res => {
                    // 更新表格
                    self.tableData = res.rows;
                    //更新分页总条数
                    self.total = res.total;
                });
            },
            //分页页码变化
            handleCurrentChange: function (pageNum) {
                this.pageNumber = pageNum;
                this.getTableData();
            },
            handleSizeChange: function (pageSize) {
                this.pageSize = pageSize;
                this.getTableData();
            },
            getNamesOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                params.attribute = 'name';
                self.$axios_api.getAttributeList(params).then(res => {
                    self.namesOptions = res;
                });
            },
            getAppsOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                params.attribute = 'app';
                self.$axios_api.getAttributeList(params).then(res => {
                    self.appsOptions = res;
                });
            },
            getLabelsOptions: function () {
                let self = this;
                let params = {};
                params.env = self.env;
                params.attribute = 'label';
                self.$axios_api.getAttributeList(params).then(res => {
                    self.labelsOptions = res;
                });
            },
            getEnvOptions() {
                const self = this;
                let params = {};
                self.$axios_api.getEnvOptions(params).then(res => {
                    self.env = res.env_options[0].value;
                    self.envOptions = res.env_options;
                });
            },
            // 弹窗关闭按钮
            dialogEditRemoteConfigClosedFn: function () {
                this.remoteConfigFrom.id = '';
                this.remoteConfigFrom.name = '';
                this.remoteConfigFrom.value = '';
                this.remoteConfigFrom.env = '';
                this.remoteConfigFrom.app = '';
                this.remoteConfigFrom.label = '';
                this.remoteConfigFrom.type = ''
            },
            confirmButton(remoteConfigFrom) {
                this.$refs[remoteConfigFrom].validate((valid) => {
                    if (valid) {
                        this.addOrUpdateRemoteConfigFn();
                    }
                });
            },
            addOrUpdateRemoteConfigFn: function () {
                const self = this;
                let params = {};
                params.id = self.remoteConfigFrom.id;
                params.name = self.remoteConfigFrom.name;
                params.env = self.remoteConfigFrom.env;
                params.value = self.remoteConfigFrom.value;
                params.app = self.remoteConfigFrom.app;
                params.label = self.remoteConfigFrom.label;
                params.type = self.remoteConfigFrom.type;
                let data = JSON.stringify(params);
                if (params.id === '') {
                    self.$axios_api.saveRemoteConfig(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditRemoteConfigVisible = false;
                        self.getTableData();
                    })
                } else {
                    self.$axios_api.updateRemoteConfig(data).then(res => {
                        self.$message({
                            message: res,
                            type: 'success'
                        });
                        self.dialogEditRemoteConfigVisible = false;
                        self.getTableData();
                    })
                }
            },

            tableEdit: function (row) {
                const self = this;
                self.remoteConfigFrom.id = row.id;
                self.remoteConfigFrom.name = row.name;
                self.remoteConfigFrom.value = row.value;
                self.remoteConfigFrom.env = row.env.toLowerCase();
                self.remoteConfigFrom.app = row.app;
                self.remoteConfigFrom.label = row.label;
                self.remoteConfigFrom.type = row.type;
                self.dialogEditRemoteConfigVisible = true;
            },

            // 表格删除按钮
            tableDelete: function (row) {
                const self = this;
                self.$confirm('此操作将删除该条数据，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        self.deleteRemoteConfig(row);
                    })
                    .catch(() => {
                    });
            },

            deleteRemoteConfig(row) {
                const self = this;
                let params = {};
                params.id = row.id;
                params.env = self.env;
                self.$axios_api.deleteRemoteConfig(params).then(res => {
                    self.$message({
                        message: res,
                        type: 'success'
                    });
                    self.getTableData(); //更新表格当前页数据
                });
            }
        },
    };
</script>

<style scoped>
    .table-expand {
        font-size: 0;
    }

    .table-expand label {
        width: 100px;
        color: #99a9bf;
        float: left;
    }

    .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
</style>